// Money formatting shared by every finance module. Amounts are stored as
// plain numbers; the engagement's `currency` (default NZD) and `tax`
// (default "gst", or "none" for GST-exempt work such as Keynes in USD) live
// at the top level of Finance Config and decide the labels, never the maths.
export function fmtMoney(n) {
  const v = Number(n) || 0;
  const abs = Math.abs(v);
  const cents = Math.round(abs * 100) % 100 !== 0;
  const s = abs.toLocaleString(undefined, { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 });
  return `${v < 0 ? "-" : ""}$${s}`;
}
export function taxSuffix(cfg) { return cfg && cfg.tax === "none" ? "" : " + GST"; }
export function currencyPrefix(cfg) { return cfg && cfg.currency && cfg.currency !== "NZD" ? `${cfg.currency} ` : ""; }
